<template>
  <div class="bg-white font-sans antialiased text-gray-900">
    <a
      href="#content"
      class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-max focus:rounded-full focus:bg-brand-600 focus:px-5 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-white focus:shadow-float"
    >
      Aller au contenu
    </a>

    <section-header />

    <main id="content">
      <slot />
    </main>

    <section-footer />
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const env = config.public
const baseUrl = env.PUBLIC_URL.replace(/\/+$/, '')

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(getOrganizationJsonLd(baseUrl))
    },
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(getWebSiteJsonLd(baseUrl))
    }
  ]
})
</script>
